/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { css, cx } from "@panda/css";
import { EdsIcon } from "@components/elements/atoms/eds-icon";

const handleRootStyles = css({
	display: "flex",
	flexDirection: "column",
	placeItems: "center",
	height: "100%",
	cursor: "resize",
	pointerEvents: "none",
	color: "white",
});

const handleLineStyles = css({
	flexGrow: 1,
	height: "100%",
	width: "eds.dimension.2",
	backgroundColor: "eds.border.accent.default",
	pointerEvents: "auto",
	backdropFilter: "blur(50px)",
});

const handleButtonStyles = css({
	display: "flex",
	minWidth: "eds.dimension.56",
	minHeight: "eds.dimension.56",
	padding: "0",
	justifyContent: "center",
	alignItems: "center",
	borderRadius: "eds.borderRadius.full",
	borderWidth: "2px",
	borderColor: "eds.border.accent.default",
	borderStyle: "solid",
	background: "rgba(0, 0, 0, 0.15)",
	backdropFilter: "blur(50px)",
});

const handleArrowStyles = css({
	marginInline: "-3px",
});

export type CosmosCompareHandleProps = {
	className?: string;
};

export const CosmosCompareHandle = ({ className }: CosmosCompareHandleProps): React.JSX.Element | null => {
	return (
		<div className={cx("compare-slider-handle-root", handleRootStyles, className)}>
			<div className={cx("compare-slider-handle-line", handleLineStyles)}></div>
			<div className={cx("compare-slider-handle-button", handleButtonStyles)}>
				<div className={cx("compare-slider-handle-arrow", handleArrowStyles)}>
					<EdsIcon icon="ChevronLeft" size="sm" />
				</div>
				<div className={cx("compare-slider-handle-arrow", handleArrowStyles)}>
					<EdsIcon icon="ChevronRight" size="sm" />
				</div>
			</div>
			<div className={cx("compare-slider-handle-line", handleLineStyles)}></div>
		</div>
	);
};
